<template>
    <div>
        <a-modal
            :title="modalState.title"
            :visible="modalState.isShow"
            width="580px"
            @cancel="handleCancel"
        >
            <a-input-group compact style="margin-bottom:10px;" v-if="modalState.keyname">
                <a-input-search style="width: 50%" default-value="" :id="currentAppSelectSearchInput"
                                @search="onSearch"/>
            </a-input-group>

            <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType,getCheckboxProps:getCheckboxProps}"
                :columns="modalState.columns"
                :data-source="list"
                :rowKey="modalState.filterAppcode"
                :pagination="false"
                :loading="tloading"
            />

            <br/>

            <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange"
                          style="float:right;" show-less-items/>
            <br/>

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    取消
                </a-button>
                <a-button key="submit" type="primary" @click="handleOk">
                    确定
                </a-button>
            </template>
        </a-modal>
    </div>

</template>
<script>


export default {
    data() {
        return {
            selectedRowKeys: [],
            list: [],
            searchVal: '',
            pagination: {
                total: 0,
                pageSize: 10,
                current: 1,
            },
            tloading: false,
            originData: [],
            savedPages: [],
            getCheckboxProps: record => ({
                props: {
                    disabled: record.appcode === this.modalState.filterAppcode, // Column configuration not to be checked
                }
            }),
            currentAppSelectSearchInput: 'currentAppSelectSearchInput'
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props: {
        modalState: {
            title: '',
            isShow: false,
            rowsType: 'checkbox',
            selectkeys: undefined,
            filterAppcode: '',
            columns: [],
            requestType: '',
            sc_params: {}
        }
    },
    methods: {
        handlePageChange(params_page) {
            this.onModalInit(params_page)
        },
        onModalInit(pageNum) {
            let that = this;
            let c_params = {
                ...that.modalState.sc_params,
                pageSize: that.pagination.pageSize,
                page: pageNum ? pageNum : 1,
                urlparams: false,
            }
            c_params[that.modalState.keyname] = that.searchVal;
            that.tloading = true;
            that.$store.dispatch({
                type: that.modalState.requestType,
                params: c_params,
            }).then((res) => {
                if (res.data.success == 1) {
                    if (that.modalState.selectkeys) {
                        that.selectedRowKeys = that.modalState.selectkeys
                    }
                    let result = res.data.data;
                    that.originData = that.originData.concat(result.list)
                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                that.tloading = false
            })
        },

        onSearch(value) {
            this.searchVal = value;
            this.onModalInit();
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk() {
            let that = this;
            let current_keys = this.selectedRowKeys;
            let result = [];
            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = this.originData.filter(function (n) {
                    return element == n[that.modalState.filterAppcode]
                });
                if (c_item.length > 0) {
                    result.push(c_item[0])
                } else {
                    console.log("未找到对应数据【" + current_keys[index] + "】")
                }

            }
            this.$emit('onModalHide', result);
            this.selectedRowKeys = [];
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide', undefined);
        }
    },
    mounted() {
    },
    watch: {
        'modalState.isShow'(newVal) {
            if (newVal) {
                setTimeout(() => {
                    document.getElementById('currentAppSelectSearchInput').focus()
                }, 500);
                this.onModalInit(1);
            }
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}
</style>
